// components/ui/ContinueCard.tsx
import { Link } from 'react-router-dom';

interface ContinueCardProps {
  videoId: string;
  lessonTitle: string;
  chapterName: string;
  subjectName: string;
  chapterId: string;
  subjectId: string;
}

function extractYouTubeVideoId(url: string): string {
  // If it's already just an ID
  if (/^[a-zA-Z0-9_-]{11}$/.test(url)) return url;
  return url;
}

export default function ContinueCard({ videoId, lessonTitle, chapterName }: ContinueCardProps) {
  const ytId = extractYouTubeVideoId(videoId);

  return (
    <Link
      to={`/watch/${ytId}?mode=course`}
      className="touch-card block rounded-3xl overflow-hidden shadow-card animate-fade-up"
    >
      <div className="relative gradient-mint p-5 pb-6">
        {/* Decorative blobs */}
        <div className="absolute top-2 right-4 w-16 h-16 bg-white/10 rounded-full blur-xl" />
        <div className="absolute bottom-1 left-8 w-20 h-20 bg-white/10 rounded-full blur-2xl" />
        
        <div className="relative z-10">
          <div className="flex items-center gap-2 mb-2">
            <span className="text-white/80 text-sm font-medium">▶ Continue</span>
          </div>
          <h3 className="text-white font-bold text-lg leading-snug line-clamp-2">
            {lessonTitle}
          </h3>
          <p className="text-white/70 text-xs mt-1.5">{chapterName}</p>
          
          <div className="mt-4 inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm text-white text-sm font-semibold px-4 py-2 rounded-xl">
            Resume
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
            </svg>
          </div>
        </div>
      </div>
    </Link>
  );
}
